import * as TAGS_ACTION_TYPE from './tagConstants';
import { Tag } from './tagTypes';

export const loadTags = (tags = []) => ({
    type: TAGS_ACTION_TYPE.TAGS_LOAD,
    tags,
});

export const createTag = (tag: Tag) => ({
    type: TAGS_ACTION_TYPE.TAG_CREATE,
    tag,
    sync: true,
});

export const updateTag = (tagId: string, changes: Partial<Tag>) => ({
    type: TAGS_ACTION_TYPE.TAG_UPDATE,
    tagId,
    changes,
    sync: true,
});

export const deleteTag = (tagId: string) => ({
    type: TAGS_ACTION_TYPE.TAG_DELETE,
    tagId,
    sync: true,
});
